import { render, staticRenderFns } from "./ClientCourseAssignment.vue?vue&type=template&id=5fde1080&"
import script from "./ClientCourseAssignment.vue?vue&type=script&lang=js&"
export * from "./ClientCourseAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports